import {FieldValidatorType} from "@progress/kendo-react-form";

export const maxNumber24Validator: FieldValidatorType = (value: any) => {
    return (parseInt(value)<=24 && parseInt(value)>= 0) || (value === undefined) || (value === "") || (value === null)  ? "" : "Il valore massimo è 24";
}


